import 'globals';

(function (window, document) {
    /**
     * Check if a device is using touch
     *
     * @return {boolean}
     */
    window.isTouchDevice = function() {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    }

    /**
     * Get cookie value by name
     *
     * @param {string} cName Cookie-Name
     * @returns {string}
     */
    window.getCookie = function (cName) {
        const name = cName + "=",
            decodedCookie = decodeURIComponent(document.cookie),
            ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];

            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    /**
     * Set a Cookie
     *
     * @param {string} cName Cookie-Name
     * @param {string|number|boolean} cValue Cookie-Value
     * @param {number} exDays if 0 => Session-Cookie
     */
    window.setCookie = function (cName, cValue, exDays) {
        let expires = '';

        if (exDays !== 0) {
            const d = new Date();
            d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        }

        document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
    }
})(window, document);

$('.file-upload .form-control').on('click', function() {
    $(this).parent().find('input[type="file"]').trigger('click');
});

$('input[type="file"]').on('change', function (e) {
    let fileName;
    const fileTextElement = $(this).parent().find('.file-upload-text');

    if($(this).val()) {
        fileName = e.target.files[0].name;
    } else {
        fileName = $(fileTextElement).data('placeholder');
    }

    fileTextElement.html(fileName);
});
